import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";
import { Ankaadia } from "../../theme/preset";

@Injectable({ providedIn: "root" })
export class SidenavStyle extends BaseStyle {
  override name = "sidenav";

  override theme = ({ dt }: any): string => `
    .ui-sidenav {
      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;
      background: ${dt("sidenav.background.left")};
      color: ${dt("sidenav.color")};
    }

    .ui-sidenav-panel {
      display: flex;
      flex-direction: column;
      flex: auto;
      overflow-y: auto;
      gap: ${dt("sidenav.panel.gap")};
      padding: ${dt("sidenav.panel.main.padding")};
      border-inline-end-width: ${dt("sidenav.separator.width")};
      border-inline-end-color: ${dt("sidenav.separator.color")};
    }

    .ui-sidenav-list {
      display: flex;
      flex-direction: column;
      gap: ${dt("sidenav.list.gap")};
    }

    .ui-sidenav-list.ui-sidenav-secondary {
      margin-top: auto;
    }

    @media (width < ${Ankaadia.semantic.breakpoint.laptop}) {
      .ui-sidenav-panel {
        min-width: unset;
      }
    }

    @media (width < ${Ankaadia.semantic.breakpoint.mobile}) {
      .ui-sidenav {
        flex-direction: row;
      }

      .ui-sidenav-panel {
        flex-direction: row;
        justify-content: space-evenly;
        gap: 0;
        border-inline-end-width: 0;
        border-block-start-width: ${dt("sidenav.separator.width")};
        border-block-start-color: ${dt("sidenav.separator.color")};
        padding: ${dt("sidenav.panel.main.mobile.padding")};
        padding-block-end: calc(${dt("padding.8")} + env(safe-area-inset-bottom, 0px));
      }

      .ui-sidenav-list {
        display: contents;
      }
    }
  `;

  override classes = {
    root: "ui-sidenav",
    panel: "ui-sidenav-panel",
    list: "ui-sidenav-list",
    secondary: "ui-sidenav-secondary",
  };
}
